<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>
      <a [routerLink]="['/activatedprocess']">Activated Process List</a>
    </li>
    <!-- <li>
        <span>{{PageTitle}}</span>
    </li> -->
  </ul> 
  <section class="card">
    <div class="card-header"> 
      <span class="cat__core__title"> 
        <strong>Activated Process Task List</strong> 
      </span>
      <button type="button" class="btn btn-sm btn-default pull-right btn-back" (click)="back()"> 
        <i class="fa fa-chevron-circle-left"></i>&nbsp;Back 
      </button>
    </div>
   
    <div class="card-block datatable-card-block">
      <!-- Completion button - will be positioned next to DataTables buttons via CSS -->
      <button type="button" class="btn btn-sm btn-primary completionBtn" [disabled]="!IsSelectedTasks"
        (click)="showStatusandUploadProofDialog()" data-toggle="modal" data-target="#uploadProofDialog"
        [appHasPermission]="{'Url': '/process/activatedTasks/edit?goveva=true&email=', 'method':'put', 'menu': 'ActivatedProcessTasks'}">
        <i class="fa fa-save"></i>&nbsp;Completion of Task 
      </button>
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive" style="position: relative;">
              <!-- Loader overlay for Activated Process Task List -->
              <div class="activated-process-task-loader-overlay" *ngIf="isLoading">
                <div class="activated-process-task-loader-container">
                  <img src="assets/images/DigiCompany_loader.png" class="activated-process-task-spinner" alt="Loading..." />
                </div>
              </div>
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                class="table table-hover compact cell-border nowrap stripe" id="activatedprocesstaskTable"
                style="cursor: pointer;">
  
                <thead>
                  <tr>
                    <th style="display: none"></th> 
                    <th>
                      <div class="md-checkbox"> 
                        <input id="selectcheckboxall" class="md-checkbox" type="checkbox" [(ngModel)]="selectedAll"
                          (change)="selectAll();" />
                        <label for="selectcheckboxall">&nbsp;</label>
                      </div>
                    </th> 
                    <!-- <th class="activatedTask-list-column">Process Name </th> -->
                    <th class="activatedTask-list-column" >Task Name </th>
                    <th class="activatedTask-list-column">Task Particulars</th> 
                    <th class="activatedTask-list-column">Tag</th>
                    <th class="activatedTask-list-column">Assigned To</th>
                    <!-- <th class="activatedTask-list-column">Responsible User</th> -->
                    <th>Due Date</th>
                    <th>Completion Date</th>
                    <th>Task Status </th>
                    <th style="display:none">Document Proof</th>
                    <th>Action</th>
                    <th style="display:none">Due Date</th>
                    <th style="display:none">Completion Date</th>
  
                  </tr>
                </thead>
  
                <tbody>
                  <tr *ngFor="let companytask of companytasklist; let count=index">
                    <td tabindex="1" style="display: none">{{companytask.ID}}</td>
                    <td>
                      <div class="md-checkbox">
                        <input id="selectcheckbox{{count +1 }}" type="checkbox" [(ngModel)]="companytask.SelectedTask"
                          (change)="checkIfAllSelected();" (change)="checkselected($event);">
                        <label for="selectcheckbox{{count +1 }}">&nbsp;</label>
                      </div>
                    </td>
  
                    <!-- <td class="activatedTask-list-column">{{companytask.ProcessName}}</td> -->
                    <td class="activatedTask-list-column" style="white-space: normal !important;">{{companytask.TaskName }} </td>
                    <td><span
                        *ngIf="companytask.ActivatedTaskParticularId!= undefined && companytask.ActivatedTaskParticularId!= null; else noTaskParticulars">{{companytask.TaskParticulars }}</span>
                      <ng-template #noTaskParticulars></ng-template>
                    </td>
                    <td class="activatedTask-list-column">{{companytask.GroupName }} </td>
                    <td class="activatedTask-list-column">{{companytask.AssignedUserName}} </td>
                    <!-- <td class="activatedTask-list-column">{{companytask.ResponsibleUserName}}  </td> -->
                    <td><span *ngIf="companytask.DueDate && companytask.DueDate!=null;else notdueDate"><span
                          style="display: none">{{companytask.DueDate | date : "yMMdd"}}</span>{{companytask.DueDate  | date : "dd-MM-y" }}</span>
                      <ng-template #notdueDate></ng-template>
                    </td>
                    <td><span *ngIf="companytask.CompletedDate && companytask.CompletedDate!=null;else notcompDate"><span
                          style="display: none">{{companytask.CompletedDate | date : "yMMdd"}}</span>{{companytask.CompletedDate  | date : "dd-MM-y" }}</span>
                      <ng-template #notcompDate></ng-template>
                    </td>
  
                    <!-- <td> <span *ngIf="companytask.TaskStatus && companytask.TaskStatus===1">Pending</span><span *ngIf="companytask.TaskStatus && companytask.TaskStatus===2">Completed</span><span *ngIf="companytask.TaskStatus && companytask.TaskStatus===3">Delayed Completion</span> <span *ngIf="companytask.TaskStatus && companytask.TaskStatus===4">Partially Completed</span> <span *ngIf="companytask.TaskStatus && companytask.TaskStatus===5">N/A</span><span *ngIf="companytask.TaskStatus && companytask.TaskStatus===6">Done</span><span *ngIf="companytask.TaskStatus && companytask.TaskStatus===7">Cancelled</span></td> -->
                    <td>{{getTaskStatus(companytask.DueDate,companytask.CompletedDate,companytask.TaskStatus)}}</td>
                    <td style="display:none">
                      <span *ngIf="companytask.DocumentID && companytask.DocumentID!=null;else notdocument">
                        <a href="{{downloadLink}}{{companytask.DocumentID}}\{{tokenForFile}}"
                          class="btn btn-sm btn-primary">
                          <span class="fa fa-download"></span>
                        </a>
  
                        <a target="_blank" data-toggle="modal" data-target="#confirmation"
                          (click)="setid(companytask.ID,companytask.DocumentID);" class="btn btn-sm btn-danger">
                          <span class="fa fa-trash"></span>
                        </a>
  
                        <ng-template #notdocument></ng-template>
                      </span>
                    </td>
                    <td>
                      <button type="button" class="btn-sm btn btn-warning" (click)="EditTask(companytask.ID)">
                        <span class="fa fa-pencil"></span>
                      </button>&nbsp;&nbsp;&nbsp;
                    </td>
                    <td style="display:none"><span
                        *ngIf="companytask.DueDate && companytask.DueDate!=null;else notdueDate1">{{companytask.DueDate  | date : "dd-MM-y" }}</span>
                      <ng-template #notdueDate1></ng-template>
                    </td>
                    <td style="display:none"><span
                        *ngIf="companytask.CompletedDate && companytask.CompletedDate!=null;else notcompDate1">{{companytask.CompletedDate  | date : "dd-MM-y" }}</span>
                      <ng-template #notcompDate1></ng-template>
                    </td>
  
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  
    <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
      aria-labelledby="" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabelForDelete">
              <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                Are you sure you want to delete the Proof?
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-danger" (click)="deleteProof()">
              <i class="fa fa-check"></i> &nbsp;Yes</button>
            <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
              <i class="fa fa-times"></i> &nbsp;No</button>
  
          </div>
        </div>
      </div>
    </div>
  
  
  
    <div class="modal fade modal-size-medium" id="uploadProofDialog" tabindex="-1" role="dialog" aria-labelledby=""
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <form [formGroup]="uploadProofactivatedTaskForm" class="well">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myModalLabel">Upload Proof</h5>
              <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-4">
                  <label class="form-control-label" for="l0">Task Status </label>
                </div>
                <div class="col-md-8">
                  <div class="form-group">
                    <select [formControl]="uploadProofactivatedTaskForm.controls['TaskStatus']"
                      class="form-control select" [(ngModel)]="TaskStatusModel">
                      <!-- <option value="0">Select</option>  -->
                      <option *ngFor="let taskStatus of taskStatusTypes" value={{taskStatus.id}}>
                        {{taskStatus.name}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="(TaskStatusModel!= undefined && TaskStatusModel==2)">
  
                <div class="col-md-4">
                  <label class="form-control-label" for="l0">Completed Date</label>
                </div>
                <div class="col-md-8">
                  <div class="form-group">
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="uploadProofactivatedTaskForm.controls['CompletedDate']"
                        [(ngModel)]="CompletedDateModel" style="padding:6px;" placeholder="dd-mm-yyyy"
                        name="dtCompletedDate" ngbDatepicker #c="ngbDatepicker" [maxDate]="todaysDate"
                        (click)="c.toggle();" (document:click)="c.close();">
  
                      <button class="input-group-addon" (click)="c.toggle();" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
  
                    <div *ngIf="(TaskStatusModel==='2' && (CompletedDateModel===undefined || CompletedDateModel===null))"
                      class="form-control-error-custom">
                      Please Select Date.
                    </div>
                  </div>
                </div>
  
              </div>
              <!-- <div class="row">
                  <div class="col-md-4">
                    <label class="col-form-label" for="l5">Upload Proof </label>
                  </div>
                  <div class="col-md-8">
                    <div class="form-group">
                        <input class="form-control" id="avatar" type="file" [formControl]="uploadProofactivatedTaskForm.controls['fileData']" (change)="onFileChange($event)"
                        accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt,.pptx, .mp4">
                        <span style="color: red" *ngIf="!fileExtension">Please upload valid file only.</span>
                    </div>
                  </div>
              </div> -->
            </div>
            <div class="modal-footer">
              <button id="btnUploadProof" type="button" class="btn btn-sm btn-primary" *ngIf="count == 1"
                (click)="initiateUploadProof()">
                <i class="fa fa-save"></i>&nbsp;Upload Proof</button>
              <button id="btnUploadProof" type="button" class="btn btn-sm btn-primary"
                [disabled]="(TaskStatusModel==='2' && (CompletedDateModel===undefined || CompletedDateModel===null) || !fileExtension)"
                (click)="uploadProofDocument()"><i class="fa fa-save"></i>Update Status</button>
              <button type="button" class="btn btn-sm" data-dismiss="modal"> <i class="fa fa-times"></i>Close</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="modal fade modal-size-large" id="uploadProofDialog1" tabindex="-1" role="dialog" data-backdrop="static"
      data-keyboard="false" aria-labelledby="" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <em class="fa fa-upload"></em>
              <span id="uploadProofDialogTitle"></span>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <em class="fa fa-times"></em>
            </button>
          </div>
          <div class="modal-body">
                <span class="cat__core__title">
                  Existing Files
                </span>
  
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="groupTable" class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
                  <caption></caption>
                  <thead>
                    <tr>
  
                      <th scope="head">Filename</th>
                      <th scope="head">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let proof of taskProofData; let count=index">
  
                      <td tabindex="1" style="cursor: move; width: 70%;">
                        {{proof.DocName}}
                      </td>
                      <td>
                        <button type="button" class="btn-sm btn btn-warning"
                          (click)="downloadDoc(proof.DocumentManagementID)">
                          <span class="fa fa-download"></span>
                        </button>
                        <button type="button" class="btn-sm btn btn-danger"
                          (click)="deleteProofDoc(proof._id,proof.DocumentManagementID)">
                          <span class="fa fa-close"></span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div class="col-md-4">
                    <label class="col-form-label" for="l5">
                      <span>Upload Proof
                        <span _ngcontent-c2="" style="color: red;">*</span>
                      </span>
                    </label>
                  </div>
                  <div class="col-md-8">
                    <div class="form-group">
                      <input type="file" class='form-control fileUpload' (change)="proofChangeEvent($event)"
                        accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx"
                        multiple />
                      <span *ngIf="typeHasError" style="color: red">
                        Please upload valid file format.
                      </span>
  
                    </div>
                    <!-- {{fileHasError | json}} -->
                  </div>
                </div>
  
              <!-- </div>
            </div> -->
          </div>
          <div class="modal-footer">
  
            <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary" (click)="uploadProofFile()">
              <em class="fa fa-save"></em>&nbsp;Upload</button>
  
            <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
              <em class="fa fa-times"></em>&nbsp;Close</button>
  
          </div>
        </div>
      </div>
    </div>
  
    <div class="modal fade" id="deletePdfConfirmation" tabindex="-1" role="dialog" data-backdrop="static"
      data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabelForDeletion">
              <em class="fa fa-question-circle-o mr-2"></em>Confirm</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <em class="fa fa-times"></em>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                Are you sure you want to delete this proof document?
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-danger" (click)="removeDoc()" data-dismiss="modal">
              <em class="fa fa-check"></em>&nbsp;Yes</button>
            <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
              <em class="fa fa-times"></em>&nbsp;No</button>
          </div>
        </div>
      </div>
    </div>
  
  </section>
  <app-alert></app-alert>